<div class="container">
	<div class="item">
		<mat-icon matTooltip="COLOCAR EM ORDEM" [matMenuTriggerFor]="ordenacao">format_line_spacing</mat-icon>
		<mat-menu #ordenacao="matMenu">
			<button mat-menu-item class="menu-itens" (click)="orderBy('')"
				[ngClass]="(ordenacaoInput === '') ? 'destacaTexto':'normalTexto' ">Ordenação Padrão</button>
			<mat-divider></mat-divider>
			<button mat-menu-item class="menu-itens" (click)="orderBy('nome')"
				[ngClass]="(ordenacaoInput === 'nome') ? 'destacaTexto':'normalTexto' ">Nome do Item</button>
			<mat-divider></mat-divider>
			@if (isPesquisaSearchbar) {
			<button mat-menu-item class="menu-itens" (click)="orderBy('relevancia')"
				[ngClass]="(ordenacaoInput === 'relevancia') ? 'destacaTexto':'normalTexto' ">Relevância</button>
			}
			@if (isPesquisaSearchbar) {
			<mat-divider></mat-divider>
			}
			<button mat-menu-item class="menu-itens" (click)="orderBy('codigoItem')"
				[ngClass]="(ordenacaoInput === 'codigoItem') ? 'destacaTexto':'normalTexto' ">Código do Item</button>
			<mat-divider></mat-divider>
			<button mat-menu-item class="menu-itens" (click)="orderBy('preco')"
				[ngClass]="(ordenacaoInput === 'preco') ? 'destacaTexto':'normalTexto' ">Preço</button>
			<mat-divider></mat-divider>
			<button mat-menu-item class="menu-itens" (click)="orderBy('codigoFabricante')"
				[ngClass]="(ordenacaoInput === 'codigoFabricante') ? 'destacaTexto':'normalTexto' ">Código do
				Fabricante</button>
			<mat-divider></mat-divider>
		</mat-menu>
	</div>
	<!-- Seletor de layout (grupo) e filtro ficam lado a lado, mas o filtro é um botão independente -->
	<div class="item item-acoes">
		@if (!isLayoutMobile) {
		<div class="grupo-layout" role="group" aria-label="Layout de exibição">
			<button type="button" class="botao-layout" (click)="selecionarLayout(1)" matTooltip="LISTA" [class.layout-ativo]="layoutAtual === 1">
				<mat-icon>list_alt</mat-icon>
			</button>
			<button type="button" class="botao-layout" (click)="selecionarLayout(2)" matTooltip="CARDS" [class.layout-ativo]="layoutAtual === 2">
				<mat-icon>border_all</mat-icon>
			</button>
			<button type="button" class="botao-layout" (click)="selecionarLayout(3)" matTooltip="TABELA" [class.layout-ativo]="layoutAtual === 3">
				<mat-icon>view_list</mat-icon>
			</button>
		</div>
		}
		<mat-icon class="icone-filtro" (click)="abrirFiltro(statusFiltro)" [matTooltip]="toolTipFiltro">tune</mat-icon>
	</div>
</div>
